"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDialogPM = void 0;
const Entities_1 = require("../../Entities");
class AlertDialogPM {
    updateAlertObserver(alert) {
        if (alert === this.observingAlert)
            return;
        if (this.observingAlert !== null) {
            this.observingAlert.removeObserver(this.doUpdateView);
        }
        if (alert !== null) {
            alert.addObserver(this.doUpdateView);
        }
        this.observingAlert = alert;
    }
    vmHasChanged(vm) {
        var _a, _b, _c;
        if (this.lastVM === undefined)
            return true;
        if (vm === null && this.lastVM === null)
            return false;
        if ((vm === null || vm === void 0 ? void 0 : vm.buttonLabel) === ((_a = this.lastVM) === null || _a === void 0 ? void 0 : _a.buttonLabel) &&
            (vm === null || vm === void 0 ? void 0 : vm.message) === ((_b = this.lastVM) === null || _b === void 0 ? void 0 : _b.message) &&
            (vm === null || vm === void 0 ? void 0 : vm.title) === ((_c = this.lastVM) === null || _c === void 0 ? void 0 : _c.title)) {
            return false;
        }
        return true;
    }
    constructor(repo, updateView) {
        this.repo = repo;
        this.updateView = updateView;
        this.observingAlert = null;
        this.doUpdateView = () => {
            let vm = null;
            if (this.repo.activeDialog &&
                this.repo.activeDialog.type === Entities_1.alertDialogType) {
                const alertDialog = this.repo.activeDialog;
                this.updateAlertObserver(alertDialog);
                vm = {
                    buttonLabel: alertDialog.buttonLabel,
                    close: alertDialog.close,
                    message: alertDialog.message,
                    title: alertDialog.title,
                };
            }
            else {
                this.updateAlertObserver(null);
            }
            if (!this.vmHasChanged(vm))
                return;
            this.updateView(vm);
            this.lastVM = vm;
        };
        this.dispose = () => {
            this.repo.removeObserver(this.doUpdateView);
            if (this.observingAlert) {
                this.observingAlert.removeObserver(this.doUpdateView);
            }
        };
        repo.addObserver(this.doUpdateView);
        this.doUpdateView();
    }
}
exports.AlertDialogPM = AlertDialogPM;
